import { NgClass } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterLink,
} from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ApiServiceService } from '../api-service.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [RouterLink, NgClass, MatIconModule],
})
export class HeaderComponent implements OnInit {
  activeDropdown: string | null = null;
  projectName = environment.projectName;
  env = environment.env;
  currentTheme: 'light' | 'dark' = 'light';

  // Dashboard
  //// Active Highlight
  isDashboardActive = true;
  isDashboardNavItemActive = false;
  isTicketDashboardNavItemActive = false;
  //// View Permission
  DashboardTabView = false;
  DeviceDashboardView = false;
  TicketDashboardView = false;

  // Device Utility
  //// Active Highlight
  isDeviceUtilityActive = false;
  isTicketListNavItemActive = false;
  isGovernmentServerNavItemActive = false;
  isFOTANavItemActive = false;
  isOTANavItemActive = false;
  isDeviceModelNavItemActive = false;
  isDealerFOTANavItemActive = false;
  isDispatchDeviceNavItemActive = false;
  //// View Permission
  DeviceUtilityTabView = false;
  MyActivationsView = false;
  GovernmentServersView = false;
  DeviceFotaView = false;
  DeviceOtaView = false;
  ModelView = false;
  DealerFotaDashboardView = false;
  DispatchDeviceView = false;

  // Reports
  //// Active Highlight
  isReportsActive = false;
  isAPIRequestLogsReportsActive = false;
  isAPIResponseLogsReportsActive = false;
  isAPILogsReportsActive = false;
  isSIMDataReportsActive = false;
  isDeviceStateConfigActive = false;
  isDeviceVinConfigActive = false;
  isDeviceSystemActivityLogActive = false;
  //// View Permission
  ReportsView = false;
  AIS140TicketTMLRequestLogsView = false;
  AIS140TicketAEPLResponseLogsView = false;
  AIS140TicketStatusUpdateLogsView = false;
  SIMBatchDataDetailsView = false;
  DeviceStateConfigView = false;
  DeviceVinConfigView = false;
  DeviceSystemActivityLogView = false;
  // Users
  //// Active Highlight
  isUserTabActive = false;
  isUserManagementActive = false;
  isUserRoleActive = false;
  isGroupManagementActive = false;
  //// View Permission
  UserView = false;
  UserManagementView = false;

  // Profile
  //// Active Highlight
  ProfileView = false;
  //// View Permission
  isProfileActive = false;

  userRole: string | undefined;
  roleType = '';
  userPermission = [];
  userName = '';
  isMenuOpen = false;
  activeSubMenu = '';

  constructor(
    public apiMicroservice: ApiServiceService,
    public router: Router,
    private activatedRoute: ActivatedRoute
  ) {}
  ngOnInit(): void {
    this.setInitialTheme();
    this.checkToken();
    this.setNavMenuNavItemPermission();
    this.highlightActiveNavMenuNavItem();
  }

  setInitialTheme() {
    const savedTheme = localStorage.getItem('theme');
    this.currentTheme = savedTheme === 'dark' ? 'dark' : 'light';
    this.applyTheme();
  }

  toggleTheme() {
    this.currentTheme = this.currentTheme === 'light' ? 'dark' : 'light';
    localStorage.setItem('theme', this.currentTheme);
    this.applyTheme();
  }

  applyTheme() {
    document.body.classList.toggle('theme-dark', this.currentTheme === 'dark');
    document.body.classList.toggle(
      'theme-light',
      this.currentTheme === 'light'
    );
    window.dispatchEvent(
      new CustomEvent('themeChanged', { detail: this.currentTheme })
    );
  }

  checkToken() {
    if (!sessionStorage.getItem('token')) {
      this.router.navigate(['/login']);
    }
  }

  setNavMenuNavItemPermission() {
    this.userName = this.apiMicroservice.decryptData(
      sessionStorage.getItem('userName') || ''
    );
    this.userRole = this.apiMicroservice.decryptData(
      sessionStorage.getItem('userRole') || ''
    );
    this.roleType = this.apiMicroservice.decryptData(
      sessionStorage.getItem('roleType') || ''
    );
    this.userPermission = JSON.parse(
      sessionStorage.getItem('userPermission')
        ? this.apiMicroservice.decryptData(
            sessionStorage.getItem('userPermission') || '[]'
          )
        : '[]'
    );
    this.userPermission.forEach(
      (element: {
        pageName: string;
        view: boolean;
        create: boolean;
        delete: boolean;
        update: boolean;
      }) => {
        // Nav Component Dashboard
        if (element.pageName === 'Device Dashboard' && element.view === true) {
          this.DeviceDashboardView = true;
        }
        if (element.pageName === 'Ticket Dashboard' && element.view === true) {
          this.TicketDashboardView = true;
        }
        if (
          this.DeviceDashboardView === true ||
          this.TicketDashboardView === true
        ) {
          this.DashboardTabView = true;
        }

        // Nav Component Device Utility
        if (
          element.pageName === 'My AIS 140 Tickets' &&
          element.view === true
        ) {
          this.MyActivationsView = true;
        }
        if (
          element.pageName === 'Government Servers' &&
          element.view === true
        ) {
          this.GovernmentServersView = true;
        }
        if (element.pageName === 'FOTA Batch' && element.view === true) {
          this.DeviceFotaView = true;
        }
        if (element.pageName === 'OTA Batch' && element.view === true) {
          this.DeviceOtaView = true;
        }
        if (element.pageName === 'Device Model' && element.view === true) {
          this.ModelView = true;
        }
        if (element.pageName === 'Dealer FOTA' && element.view === true) {
          this.DealerFotaDashboardView = true;
        }
        if (element.pageName === 'Dispatch Device' && element.view === true) {
          this.DispatchDeviceView = true;
        }
        if (
          this.MyActivationsView === true ||
          this.GovernmentServersView === true ||
          this.DeviceFotaView === true ||
          this.DeviceOtaView === true ||
          this.ModelView === true ||
          this.DealerFotaDashboardView === true ||
          this.DispatchDeviceView === true
        ) {
          this.DeviceUtilityTabView = true;
        }

        // Nav Component Reports
        if (
          element.pageName === 'AIS140 Ticket TML Request Logs' &&
          element.view === true
        ) {
          this.AIS140TicketTMLRequestLogsView = true;
        }
        if (
          element.pageName === 'AIS140 Ticket AEPL Response Logs' &&
          element.view === true
        ) {
          this.AIS140TicketAEPLResponseLogsView = true;
        }
        if (
          element.pageName === 'AIS140 Ticket Status Update Logs' &&
          element.view === true
        ) {
          this.AIS140TicketStatusUpdateLogsView = true;
        }
        if (element.pageName === 'SIM Data Details' && element.view === true) {
          this.SIMBatchDataDetailsView = true;
        }
        if (
          element.pageName === 'Device State Config' &&
          element.view === true
        ) {
          this.DeviceStateConfigView = true;
        }
        if (element.pageName === 'Device Vin Config' && element.view === true) {
          this.DeviceVinConfigView = true;
        }
        if (
          element.pageName === 'Device System Activity Log' &&
          element.view === true
        ) {
          this.DeviceSystemActivityLogView = true;
        }
        if (
          this.AIS140TicketTMLRequestLogsView === true ||
          this.AIS140TicketAEPLResponseLogsView === true ||
          this.AIS140TicketStatusUpdateLogsView === true ||
          this.SIMBatchDataDetailsView === true ||
          this.DeviceStateConfigView === true ||
          this.DeviceVinConfigView === true ||
          this.DeviceSystemActivityLogView === true
        ) {
          this.ReportsView = true;
        }

        // Nav Component User
        if (element.pageName === 'User Management' && element.view === true) {
          this.UserManagementView = true;
        }
        if (this.UserManagementView === true) {
          this.UserView = true;
        }

        // Nav Component Profile
        if (element.pageName === 'User Profile' && element.view === true) {
          this.ProfileView = true;
        }
      }
    );
  }

  highlightActiveNavMenuNavItem() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        // Check if the current route is a child route of `Device Utility`
        this.isDashboardActive = this.checkIfActive([
          'device-dashboard',
          'device-details',
          'ticket-dashboard-page',
        ]);
        this.isDashboardNavItemActive = this.checkIfActive([
          'device-dashboard',
          'dashboard-details',
        ]);
        this.isTicketDashboardNavItemActive = this.checkIfActive([
          'ticket-dashboard-page',
        ]);
        this.isDeviceUtilityActive = this.checkIfActive([
          'ais140-ticket-list',
          'institutional-sales',
          'dealer-master',
          'ais140-ticket-details',
          'ticket-assignment-page',
          'govt-servers',
          'govt-servers-add',
          'fota-batch-list',
          'fota-batch-details',
          'fota-batch-report',
          'manual-fota',
          'Ota-batch-list',
          'ota-batch-view',
          'ota-batch-create',
          'Ota-batch-report',
          'ota-master',
          'manual-ota',
          'device-model-list',
          'device-model-details',
          'dealer-fota',
          'dealer-fota-approved-files',
          'dispatch-device-list',
          'dispatch-device-add',
        ]);
        this.isTicketListNavItemActive = this.checkIfActive([
          'ais140-ticket-list',
          'institutional-sales',
          'dealer-master',
          'ais140-ticket-details',
          'ticket-assignment-page',
        ]);
        this.isGovernmentServerNavItemActive = this.checkIfActive([
          'govt-servers',
          'govt-servers-add',
        ]);
        this.isFOTANavItemActive = this.checkIfActive([
          'fota-batch-list',
          'fota-batch-details',
          'fota-batch-report',
          'manual-fota',
        ]);
        this.isOTANavItemActive = this.checkIfActive([
          'Ota-batch-list',
          'ota-batch-view',
          'ota-batch-create',
          'Ota-batch-report',
          'ota-master',
          'manual-ota',
        ]);
        this.isDeviceModelNavItemActive = this.checkIfActive([
          'device-model-list',
          'device-model-details',
        ]);
        this.isDealerFOTANavItemActive = this.checkIfActive([
          'dealer-fota',
          'dealer-fota-approved-files',
        ]);
        this.isDispatchDeviceNavItemActive = this.checkIfActive([
          'dispatch-device-list',
          'dispatch-device-add',
        ]);
        this.isReportsActive = this.checkIfActive([
          'ais140-api-req-logs',
          'ais140-api-res-logs',
          'ais140-tml-api-logs',
          'sim-data-details',
          'device-state-config',
          'device-vin-config',
          'device-system-activity-log',
        ]);
        this.isAPIRequestLogsReportsActive = this.checkIfActive([
          'ais140-api-req-logs',
        ]);
        this.isAPIResponseLogsReportsActive = this.checkIfActive([
          'ais140-api-res-logs',
        ]);
        this.isAPILogsReportsActive = this.checkIfActive([
          'ais140-tml-api-logs',
        ]);
        this.isSIMDataReportsActive = this.checkIfActive(['sim-data-details']);
        this.isDeviceStateConfigActive = this.checkIfActive([
          'device-state-config',
        ]);
        this.isDeviceVinConfigActive = this.checkIfActive([
          'device-vin-config',
        ]);
        this.isDeviceSystemActivityLogActive = this.checkIfActive([
          'device-system-activity-log',
        ]);
        this.isUserManagementActive = this.checkIfActive([
          'user-management',
          'user-permissions',
          'role-management',
          'group-management',
        ]);
        this.isUserTabActive = this.checkIfActive([
          'user-management',
          'user-permissions',
        ]);
        this.isUserRoleActive = this.checkIfActive(['role-management']);
        this.isGroupManagementActive = this.checkIfActive(['group-management']);
        this.isProfileActive = this.checkIfActive([
          'customer-setting',
          'profile',
        ]);
      });
  }

  checkIfActive(requestedRoutes: any[]): boolean {
    // Get the current route path
    const currentRoute = this.activatedRoute.firstChild?.snapshot.url
      .map((segment) => segment.path)
      .join('/');
    return requestedRoutes.some((route) => currentRoute?.includes(route));
  }

  logout() {
    sessionStorage.clear();
    localStorage.clear();
    window.location.replace('/login');
  }

  toggleDropdown(menu: string) {
    this.activeDropdown = this.activeDropdown === menu ? null : menu;
    if (!menu) {
      this.isMenuOpen = false;
    }
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const targetElement = event.target as HTMLElement;

    // Check if the clicked element is inside the dropdown or menu
    if (!targetElement.closest('.nav-item')) {
      this.activeDropdown = null;
    }
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  toggleSubMenu(subMenu: string) {
    this.activeSubMenu = this.activeSubMenu === subMenu ? '' : subMenu;
  }
}
